import { render, staticRenderFns } from "./BMW2022ChargingDisclosure.vue?vue&type=template&id=550a245a&"
import script from "./BMW2022ChargingDisclosure.vue?vue&type=script&lang=js&"
export * from "./BMW2022ChargingDisclosure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports